/*
 * NCII — Free-gift guard (v2)
 * ---------------------------
 * Keeps the Berberine free gifts honest in the cart. Whenever the cart changes
 * (and on every page load) it re-reads /cart.js and:
 *   - removes a gift whose rule is no longer met (e.g. the paid Berberine was
 *     removed, downgraded, or switched from subscribe to one-time)
 *   - caps every gift at quantity 1
 * then refreshes the cart drawer (or the /cart page) so the customer sees it.
 *
 * Only lines carrying the _gift property (added by the Berberine page) are
 * policed. The tumbler and pill organizer are also sold on their own, so a
 * paid line of the same product is never touched.
 *
 * Checkout pricing is enforced separately by Shopify automatic discounts
 * (Buy X Get Y). This file is the customer-facing half: it stops people from
 * reaching checkout with a gift they no longer qualify for.
 *
 * Loaded from blocks/cart-drawer_body.liquid, so it runs on every page.
 * To change the offer, edit BERBERINE and GIFTS below. IDs are variant IDs.
 */
(function () {
  'use strict';
  if (window.__nciiGiftGuard) return;
  window.__nciiGiftGuard = true;

  // Berberine variant ID -> tier (bottles in that variant).
  var BERBERINE = {
    52947258998952: 1, // 1 Month
    55914849796264: 2, // 2 Month
    52947259031720: 3  // 3 Month
  };

  // Gift variant ID -> rule. minBottles is the lowest Berberine tier that unlocks the
  // gift; subOnly means that tier must be on subscribe & save.
  var GIFTS = {
    55914861756584: { name: '90-Day Guide',        minBottles: 1, subOnly: false },
    55914857660584: { name: 'Pill Organizer',      minBottles: 2, subOnly: true  },
    55015321862312: { name: 'NCII Tumbler',        minBottles: 3, subOnly: true  },
    55914860019880: { name: 'Satisfied Inhaler',   minBottles: 3, subOnly: true  }
  };

  // Primal (product.ncii-pdp buy box). Gift lines carry _gift: 'primal'.
  var PRIMAL = {
    53419736039592: 1, // 1 Month
    53419736072360: 3, // 3 Month
    67615412879528: 3, // 3 Bottles (2+1 Offer) product, sold on the 2 + 1 FREE tile
    67615105745064: 6  // 6 Month
  };
  // Primal gifts are tied to one exact subscription tile (Matt, Oct 2026):
  // 2 + 1 FREE -> pill organizer; 6 bottles -> tumbler + pill organizer.
  // Berberine sample pack is off for now (Matt, Oct 6): onlyWith [] removes any stray one.
  // (Free shipping on every subscription comes from the shipping discount.)
  var PRIMAL_GIFTS = {
    55914857660584: { name: 'Pill Organizer',         onlyWith: [67615412879528, 67615105745064], subOnly: true },
    55015321862312: { name: 'NCII Tumbler',           onlyWith: [67615105745064], subOnly: true },
    67616024264872: { name: 'Berberine Sample Pack',  onlyWith: [], subOnly: true }
  };

  // Ageless Glutathione (product.ncii-ageless buy box). Gift lines carry _gift: 'ageless'.
  // Same model as Primal (Matt, Oct 29): subscriptions only, tied to the exact tier.
  // 2 Month sub -> pill organizer; 3 Month sub -> pill organizer + stainless water bottle (was tumbler;
  // Matt, Oct 30 12:04 AM). One-time: no gifts.
  // Checkout pricing: automatic BXGY discounts 6398976917672 / 6398976950440 (subscription only).
  var AGELESS_1M = 67743472189608, AGELESS_2M = 67774542282920, AGELESS_3M = 67774542315688;
  var AGELESS = {}; AGELESS[AGELESS_1M] = 1; AGELESS[AGELESS_2M] = 2; AGELESS[AGELESS_3M] = 3;
  var AGELESS_GIFTS = {
    55914857660584: { name: 'Pill Organizer', onlyWith: [AGELESS_2M, AGELESS_3M] },
    55285720449192: { name: 'NCII Water Bottle (Pink)',       onlyWith: [AGELESS_3M] },
    55285720416424: { name: 'NCII Water Bottle (Light Blue)', onlyWith: [AGELESS_3M] }
  };
  // Holy Glow intro promo (Matt, Oct 29): free 1 oz serum with every Ageless order,
  // one-time or subscription, Thu Oct 29 11 PM through Mon Nov 2 2 AM (Central; Matt, Oct 29 11:51 PM). The gift product is $0,
  // so no discount is needed. Outside these dates, or with no Ageless line, it is removed.
  var HOLY_GLOW = 67774519541928;
  var HOLY_GLOW_START = Date.parse('2026-10-29T23:00:00-05:00');
  var HOLY_GLOW_END = Date.parse('2026-11-02T02:00:00-06:00');

  // De-Bloat (default product page + Loop widget; Matt, Oct 29 8:03 PM). Subscriptions only,
  // like Primal: 2 Month sub -> pill organizer; 3 Month sub -> pill organizer + tumbler.
  // The product page has no gift picker, so the guard ADDS a missing gift (quietly, no
  // AddToCart) as well as removing one that no longer qualifies. Gift lines carry _gift: 'debloat'.
  // Checkout pricing: the shared 2-Month / 3-Month subscription gift BXGY discounts.
  var DEBLOAT_2M = 67774569349288, DEBLOAT_3M = 46972338077864;
  var DEBLOAT_GIFTS = {
    55914857660584: { name: 'Pill Organizer', onlyWith: [DEBLOAT_2M, DEBLOAT_3M] },
    55015321862312: { name: 'NCII Tumbler',   onlyWith: [DEBLOAT_3M] }
  };
  var addTries = 0;
  var recheckTries = 0;

  var origFetch = window.fetch.bind(window);
  var running = false;
  var queued = false;

  // Quiet cart writes for $0 gift lines: a fetch from a blank same-origin frame is not watched by
  // Shopify's storefront analytics, so adding a gift never fires product_added_to_cart / AddToCart
  // (checked live on Oct 29: page fetch -> add_to_cart sent; frame fetch -> none).
  var quietFrame = null;
  function quietFetch(url, init, skipCheck) {
    try {
      if (!quietFrame || !quietFrame.contentWindow) {
        quietFrame = document.createElement('iframe');
        quietFrame.setAttribute('aria-hidden', 'true');
        quietFrame.tabIndex = -1;
        quietFrame.style.cssText = 'display:none';
        document.body.appendChild(quietFrame);
      }
      var w = quietFrame.contentWindow;
      return w.fetch.call(w, location.origin + url, init).then(function (r) { if (!skipCheck) setTimeout(check, 250); return r; });
    } catch (e) {
      return origFetch(url, init);
    }
  }
  // opts.skipCheck: the caller adds the paid line right after (gifts first, so the GoodApps
  // wholesale script, which re-stamps line 1 after a page add, stamps the paid line and not a
  // gift); the guard then runs off that paid add instead of removing the gifts too early.
  window.nciiQuietCartAdd = function (items, extra, opts) {
    var body = { items: items };
    if (extra) for (var k in extra) body[k] = extra[k];
    return quietFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }, !!(opts && opts.skipCheck));
  };

  function isSub(item) {
    return !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
  }

  function corrections(cart) {
    var anyBottles = 0;
    var subBottles = 0;
    cart.items.forEach(function (item) {
      var per = BERBERINE[item.variant_id];
      if (!per) return;
      // Tiers match the Shopify automatic discounts, which key off the
      // variant (1/2/3 Month), not the number of bottles across lines.
      anyBottles = Math.max(anyBottles, per);
      if (isSub(item)) subBottles = Math.max(subBottles, per);
    });

    var pAny = 0;
    var pSub = 0;
    var pSubVariants = {};
    cart.items.forEach(function (item) {
      var per = PRIMAL[item.variant_id];
      if (!per) return;
      pAny = Math.max(pAny, per);
      if (isSub(item)) { pSub = Math.max(pSub, per); pSubVariants[item.variant_id] = true; }
    });

    var aSubVariants = {};
    var aAny = false;
    cart.items.forEach(function (item) {
      if (!AGELESS[item.variant_id]) return;
      if (item.properties && item.properties._gift) return;
      aAny = true;
      if (isSub(item)) aSubVariants[item.variant_id] = true;
    });
    var dSubVariants = {};
    cart.items.forEach(function (item) {
      if ((item.variant_id === DEBLOAT_2M || item.variant_id === DEBLOAT_3M) && isSub(item) && !(item.properties && item.properties._gift)) dSubVariants[item.variant_id] = true;
    });
    var now = Date.now();
    var promoOn = now >= HOLY_GLOW_START && now < HOLY_GLOW_END;

    var updates = {};
    var changed = false;
    var seen = {};
    // Package protection is one per order: cap a doubled line at 1 (backstop for overlapping auto-adds).
    var spSeen = false;
    cart.items.forEach(function (item) {
      if (item.handle !== 'shipping-protection') return;
      var want = spSeen ? 0 : 1; spSeen = true;
      if (item.quantity !== want) { updates[item.key] = want; changed = true; }
    });
    cart.items.forEach(function (item) {
      // Paid purchases of the same product are left alone.
      // (The $0 Holy Glow gift is policed even without _gift: it is never a paid purchase.)
      if (!(item.properties && item.properties._gift) && item.variant_id !== HOLY_GLOW) return;
      var primal = item.properties._gift === 'primal';
      var ageless = item.properties._gift === 'ageless';
      var debloat = item.properties._gift === 'debloat';
      var rule = (debloat ? DEBLOAT_GIFTS : ageless ? AGELESS_GIFTS : primal ? PRIMAL_GIFTS : GIFTS)[item.variant_id];
      if (item.variant_id === HOLY_GLOW) rule = { name: 'Holy Glow 1 oz', promo: true };
      if (!rule) return;
      var allowed;
      if (rule.promo) {
        allowed = (aAny && promoOn) ? 1 : 0;
      } else if (ageless) {
        allowed = rule.onlyWith.some(function (v) { return aSubVariants[v]; }) ? 1 : 0;
      } else if (debloat) {
        allowed = rule.onlyWith.some(function (v) { return dSubVariants[v]; }) ? 1 : 0;
      } else if (rule.onlyWith) {
        allowed = rule.onlyWith.some(function (v) { return pSubVariants[v]; }) ? 1 : 0;
      } else {
        var have = primal ? (rule.subOnly ? pSub : pAny) : (rule.subOnly ? subBottles : anyBottles);
        allowed = have >= rule.minBottles ? 1 : 0;
      }
      // A gift can appear on two lines (different properties). Allow one total.
      if (seen[item.variant_id]) allowed = 0;
      if (allowed) seen[item.variant_id] = true;
      if (item.quantity !== allowed) {
        updates[item.key] = allowed;
        changed = true;
      }
    });
    return changed ? updates : null;
  }

  // De-Bloat gifts the cart should have but doesn't. A gift line of the same product under any
  // tag counts as present (one of each gift per cart, same as the discounts' once-per-order limit).
  function debloatMissing(cart) {
    var want = {};
    cart.items.forEach(function (item) {
      if (!isSub(item) || (item.properties && item.properties._gift)) return;
      Object.keys(DEBLOAT_GIFTS).forEach(function (g) {
        if (DEBLOAT_GIFTS[g].onlyWith.indexOf(item.variant_id) !== -1) want[g] = true;
      });
    });
    cart.items.forEach(function (item) {
      if (item.properties && item.properties._gift && item.quantity > 0) delete want[item.variant_id];
    });
    return Object.keys(want).map(function (g) { return { id: Number(g), quantity: 1, properties: { _gift: 'debloat' } }; });
  }

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      try {
        return d.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function paint(parsed) {
    // Cart page: let the theme re-render, or reload as a fallback.
    if (/^\/cart\/?$/.test(location.pathname)) {
      var items = document.querySelector('cart-items');
      if (items && typeof items.onCartUpdate === 'function') {
        try { items.onCartUpdate(); } catch (e) { location.reload(); }
      } else {
        location.reload();
      }
    }

    // Drawer: swap in the fresh HTML without forcing the drawer open.
    var d = drawer();
    if (d && parsed && parsed.sections && typeof d.getSectionsToRender === 'function') {
      try {
        d.getSectionsToRender().forEach(function (s) {
          var html = parsed.sections[s.id];
          if (!html) return;
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (!el) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector(s.selector || '.shopify-section');
          if (src) el.innerHTML = src.innerHTML;
        });
        var empty = parsed.item_count === 0;
        d.classList.toggle('is-empty', empty);
      } catch (e) {}
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function check() {
    if (running) { queued = true; return; }
    running = true;
    origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        var updates = corrections(cart);
        if (!updates) {
          // Nothing to remove: add any De-Bloat subscription gift that is missing.
          var add = debloatMissing(cart);
          if (!add.length || addTries >= 3) return null;
          addTries++;
          return quietFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: add, sections: sectionIds(), sections_url: location.pathname })
          }, true)
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (parsed) {
              if (!parsed) return;
              queued = true; // re-check once, so the drawer/cart page shows the final state
              return origFetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ updates: {}, sections: sectionIds(), sections_url: location.pathname })
              }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p2) { if (p2) paint(p2); });
            });
        }
        // after a removal, look again once or twice (a De-Bloat gift may still be missing);
        // capped so a failing update can never loop
        if (++recheckTries <= 3) queued = true;
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: sectionIds(),
            sections_url: location.pathname
          })
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (parsed) { if (parsed) paint(parsed); });
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (queued) { queued = false; check(); }
      });
  }

  // Re-check after any cart mutation made by the theme or an app.
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0] || '';
    return origFetch.apply(window, args).then(function (res) {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        setTimeout(check, 250);
      }
      return res;
    });
  };

  // Older themes and some apps still use XMLHttpRequest.
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(check, 250); });
    }
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('cart:updated', check);
  // Back/forward cache restores a stale page without reloading it.
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
